import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { ProjectDataTypes } from '@mono/proto-clients';
import { Testids } from '@mono/ui-selectors';
import { useMemo } from 'react';
import { GraphCanvas } from '../../Capture/GraphCanvas';
/**
 * The map's nodes and edges, derived from exactly the members the list shows
 * (already permission-filtered by the server). The Landscape is the hub; each
 * member Opportunity is a node joined by one relationship edge. Nothing here is
 * ever written back: node position is canvas state only.
 */ export function landscapeGraph(landscapeId, landscapeName, members) {
    const nodes = [
        new ProjectDataTypes.EntityNodeView({
            id: landscapeId,
            nodeType: 'landscape',
            displayName: landscapeName || 'Landscape'
        }),
        ...members.map((m)=>new ProjectDataTypes.EntityNodeView({
                id: m.opportunityId,
                nodeType: 'opportunity',
                displayName: m.opportunityTitle || m.opportunityId
            }))
    ];
    const edges = members.map((m)=>new ProjectDataTypes.EntityEdgeView({
            id: `${landscapeId}:${m.opportunityId}`,
            fromNode: landscapeId,
            toNode: m.opportunityId,
            edgeType: m.state === 'removed' ? `${m.basis} (removed)` : m.basis,
            overrideStatus: m.state === 'removed' ? 'superseded' : 'none'
        }));
    return {
        nodes,
        edges
    };
}
const noop = ()=>{};
export function LandscapeMap({ landscapeId, landscapeName, members }) {
    const { nodes, edges } = useMemo(()=>landscapeGraph(landscapeId, landscapeName, members), [
        landscapeId,
        landscapeName,
        members
    ]);
    return /*#__PURE__*/ _jsxs("section", {
        "data-testid": Testids.landscapes.mapView,
        "data-view": "map",
        "aria-label": `Map of ${landscapeName || 'Landscape'} with ${members.length} records; switch to list view for the same records as text`,
        children: [
            /*#__PURE__*/ _jsxs("p", {
                className: "text-xs text-muted-foreground",
                children: [
                    "Optional map of this Landscape's ",
                    members.length,
                    " permitted records. Arranging nodes only changes the picture, never a relationship. The list view shows the same records."
                ]
            }),
            /*#__PURE__*/ _jsx(GraphCanvas, {
                nodes: nodes,
                edges: edges,
                onSelectNode: noop,
                onSelectEdge: noop,
                refitOnNodeChange: true
            })
        ]
    });
}
